<div class="form-group">
  <label class="label pb-0">{{ 'sign_up.company_form.company' | translate }}*</label><br />
  <div
    [class.box-success]="!companyErrors"
    [class.box-error]="companyErrors"
    class="animated fadeIn box ms-0 me-0 style-flex align-middle justify-content-between"
    *ngIf="searchItem && searchItem.search_label">
    <div class="m-2" style="vertical-align: middle">
      <span class="bigger"
        ><strong>{{ searchItem.search_label }}</strong></span
      >
      - <span>{{ searchItem.search_label_aux }}</span>
    </div>
    <button andClass="m-2" size="sm" nkButton [color]="companyErrors ? 'danger' : 'success'" (click)="removeCompany()">
      <i class="fa fa-times"></i>
    </button>
  </div>
  <div *ngIf="!searchItem">
    <div class="search-box mt-2">
      <nk-company-person-search-box
        id="sign-up-company-person-search-input"
        [searchEntityType]="'onlyCompanies'"
        [andInputClass]="showErrors && (!searchItem || !searchItem.company_uuid) ? 'form-error-highlight-override' : ''"
        [includeDeadCompanies]="false"
        [clearOnSelect]="true"
        [placeholder]="'sign_up.company_form.company_placeholder' | translate"
        [geoCountryIdentifiersOverride]="['NO']"
        (searchSelectOutput)="onSimpleSearchSelect($event)">
      </nk-company-person-search-box>
    </div>
    <p
      class="mt-2 {{ showErrors && (!searchItem || !searchItem.company_uuid) ? 'warning' : 'text-muted' }}"
      [innerHtml]="'sign_up.company_form.account_needs_to_be_registered_with_norwegian_org_nr' | translate"></p>
  </div>
  <div class="mt-2" *ngIf="showErrors && (!searchItem || !searchItem.company_uuid)">
    <p class="warning">
      <strong>{{ 'sign_up.company_form.company_error' | translate }}</strong>
    </p>
  </div>
</div>

<form [formGroup]="formGroup">
  <div class="form-group my-3 form-success-highlight" [class.form-error-highlight]="showErrors">
    <label for="phone_number" class="label">{{ 'sign_up.company_form.phone_number' | translate }}*</label>
    <input type="text" class="form-control" id="phone_number" required formControlName="phone_number" />
    <span class="warning" *ngIf="showErrors && formGroup.controls['phone_number'].errors?.required">{{
      'sign_up.company_form.phone_number_error_required' | translate
    }}</span>
    <span
      class="warning"
      *ngIf="formGroup.controls.phone_number.errors?.minlength"
      [innerHtml]="
        'sign_up.company_form.phone_number_error'
          | translate: { requiredLength: formGroup.controls.phone_number.errors?.minlength?.requiredLength }
      ">
    </span>
  </div>

  <div class="form-group my-3 form-success-highlight" [class.form-error-highlight]="showErrors">
    <label for="email" class="label">{{ 'sign_up.account_form.email' | translate }}*</label>
    <input type="email" class="form-control" id="email" required formControlName="email" />
    <p *ngIf="formGroup.controls.email.errors && showErrors" class="warning">
      <span *ngIf="showErrors && formGroup.controls.email.errors?.required">{{
        'sign_up.company_form.email_error_required' | translate
      }}</span>
      <span *ngIf="formGroup.controls.email.errors?.emailTaken">{{
        'sign_up.company_form.email_error_already_exist' | translate
      }}</span>
      <span *ngIf="formGroup.controls.email.errors?.malformed_email_flag">{{
        'sign_up.company_form.email_error_invalid' | translate
      }}</span>
      <span *ngIf="formGroup.controls.email.errors?.email">{{
        'sign_up.company_form.email_error_invalid' | translate
      }}</span>
      <span *ngIf="formGroup.controls.email.errors?.invalidFormat">
        <br />{{ formGroup.controls.email.errors.invalidFormat | translate }}
      </span>
    </p>
  </div>

  <div class="form-group my-3 form-success-highlight" [class.form-error-highlight]="showErrors">
    <label for="industry_type_key" class="label pb-0">{{ 'sign_up.company_form.industry' | translate }}*</label>
    <div class="select-wrapper mt-2">
      <select class="form-control" id="industry_type_key" required formControlName="industry_type_key">
        <option *ngFor="let industry of industryTypeKeyList" value="{{ industry }}">
          {{ 'industry_type_key.' + industry | translate }}
        </option>
      </select>
    </div>
    <span class="warning" *ngIf="showErrors && formGroup.controls['industry_type_key'].errors?.required">{{
      'sign_up.company_form.industry_type_key_error_required' | translate
    }}</span>
    <div class="text-muted mt-2">
      {{ 'sign_up.company_form.industry_help' | translate }}
    </div>
  </div>
</form>
